<template>
    <v-container class="fill-height" fluid style="background-color: gray">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="grey lighten-4">
                    <v-toolbar color="bal-red" dark flat>
                        <v-img contain max-height="50px" :src="require('../../assets/images/Balsnack-logo.png')" />
                    </v-toolbar>
                    <v-card-text v-if="!error">
                        <v-list-item-title class="headline mb-1">Reset password</v-list-item-title>
                        <v-list-item-subtitle>Insert new password.</v-list-item-subtitle>
                        <v-form v-model="form_validation">
                            <v-text-field
                                id="password"
                                label="Password"
                                name="password"
                                prepend-icon="lock"
                                :rules="[rules.password]"
                                type="password"
                                v-model="password"
                            />

                            <v-text-field
                                id="repeatPassword"
                                label="Repeat password"
                                name="repeatPassword"
                                prepend-icon="lock"
                                :rules="[rules.password]"
                                type="password"
                                v-model="repeatPassword"
                            />
                        </v-form>
                        <v-alert v-model="passwordError" type="error" color="bal-red">
                            There was problem. {{ response_error }}
                        </v-alert>
                    </v-card-text>
                    <v-card-text v-if="error">
                        <v-alert type="error" color="bal-red">
                            This link is no longer valid.
                        </v-alert>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn v-if="!error" :disabled="!form_validation" color="bal-red" dark @click="handleResetClick"
                            >Reset</v-btn
                        >
                        <v-btn v-if="error" color="bal-red" dark @click="handleBackClick">Back</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Store from "../../store";
import router from "../../router";

export default {
    name: "reset-password",
    data() {
        return {
            password: null,
            repeatPassword: null,
            error: false,
            email: null,
            hash: null,
            passwordError: null,
            form_validation: false,
            response_error: null,
            rules: {
                required: value => !!value || "Required.",
                password: value => {
                    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
                    return (
                        pattern.test(value) ||
                        "Min. 8 characters with at least one capital letter, a number and a special character."
                    );
                }
            }
        };
    },
    computed: {
        ...mapState(["user"])
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        if (params.get("e") && params.get("h")) {
            this.email = params.get("e");
            this.hash = params.get("h");
            let payload = {
                email: this.email,
                hash: this.hash
            };
            Store.dispatch("checkHashValidity", payload).then(result => {
                if (result && result.success !== 1) {
                    this.clearUrlFromParameters();
                }
            });
        } else {
            this.clearUrlFromParameters();
        }
    },
    methods: {
        ...mapActions(["checkHashValidity", "changeUserPassword"]),
        handleKeyboardListener(e) {
            if (e.keyCode === 13) {
                this.handleResetClick();
            }
        },
        clearUrlFromParameters() {
            this.error = true;
            window.history.replaceState(null, null, window.location.pathname);
        },
        async handleResetClick() {
            if (this.password === this.repeatPassword && this.password.length >= 8) {
                this.passwordError = false;
                let payload = {
                    email: this.email,
                    hash: this.hash,
                    password: this.password
                };
                let result = await this.changeUserPassword(payload);
                if (result.success === 1) {
                    await router.push("/login");
                } else {
                    this.passwordError = true;
                    this.response_error = result.msg;
                }
            } else this.passwordError = true;
        },
        handleBackClick() {
            router.push("/login");
        }
    }
};
</script>

<style scoped></style>
